import type ItemType from '../Enums/ItemType';

class Item {

    private _itemId: string;
    private _parentId: string | null;
    private _itemType: ItemType;
    private _folderId: string | null;
    private _sortIndex: number | null;

    public constructor(itemId: string, parentId: string | null, itemType: ItemType, folderId: string | null, sortIndex: number | null) {

        this._itemId = itemId;
        this._parentId = parentId;
        this._itemType = itemType;
        this._folderId = folderId;
        this._sortIndex = sortIndex;
    }

    public get itemId(): string {
        return this._itemId;
    }

    public set itemId(value: string) {
        this._itemId = value;
    }

    public get parentId(): string | null {
        return this._parentId;
    }

    public set parentId(value: string | null) {
        this._parentId = value;
    }

    public get itemType(): ItemType {
        return this._itemType;
    }

    public set itemType(value: ItemType) {
        this._itemType = value;
    }

    public get folderId(): string | null {
        return this._folderId;
    }

    public set folderId(value: string | null) {
        this._folderId = value;
    }

    public get sortIndex(): number | null {
        return this._sortIndex;
    }

    public set sortIndex(value: number | null) {
        this._sortIndex = value;
    }
}

export default Item;